<template>
  <div class="merged-detail">
    <img :src="specialData.image" class="icon-merge" v-if="specialData.image" />
    <p class="tips" v-if="specialData.description">{{specialData.description}}</p>
    <p class="btn" v-if="specialData.jumpText" @click="toThread">
      {{ specialData.jumpText }}
      <svg-icon name="icon-arrow" />
    </p>
  </div>
</template>
<script setup>
  const props = defineProps({
    specialData: {
      type: Object,
      default: {}
    }
  })

  function toThread() {
    window.location.href = props.specialData.h5JumpUrl
  }
</script>
<style lang="postcss" scoped>
  .merged-detail {
    min-height: calc(100vh - var(--orbit-nav-height, 0px) - var(--orbit-notice-height, 0px) - 144px);
    width: 556px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    .icon-merge {
      width: 280px;
      height: 200px;
    }

    .tips {
      line-height: 24px;
      font-size: 16px;
      color: var(--color-text-primary);
      letter-spacing: 0.5px;
      margin: 40px auto 16px;
    }

    .btn {
      color: rgba(0, 0, 0, 0.55);
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 16px;

      .icon-arrow {
        width: 20px;
        height: 20px;
      }
    }
  }
</style>